import type { TDatadogErrorLog } from 'utils/datadog/types'

export const CREATE_TERRITORY_NICHE_CONTEXT_HASH_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/niches-overview-section/index.ts',
  name: 'Create Territory Niche Context Hash',
  message: 'Failed to create a niche context hash for a territory',
}
